/**
 * Errand listing AJAX filter and pagination.
 */
jQuery( function( $ ) {
	const $errandSection = $( '#errand-listing-section' );

	if ( ! $errandSection.length ) {
		return;
	}

	const $filterForm = $( '#errand-filter-form' );
	const $searchForm = $( '#errand-search-form' );
	const $errandSearchInput = $( '#errand-search-input' );
	const $errandsRow = $( '#errands-row' );
	const $pagination = $( '#errands-pagination' );

	function getFilterValues() {
		return {
			category: $( '#errand-category' ).val() || '',
			location: $( '#errand-location' ).val() || '',
			budget: $( '#errand-budget' ).val() || '',
			duration: $( '#errand-duration' ).val() || '',
			search: $errandSearchInput.length ? $errandSearchInput.val().trim() : '',
		};
	}

	function updateUrlFromFilters( page ) {
		const filters = getFilterValues();
		const params = new URLSearchParams();

		if ( filters.category ) {
			params.set( 'errand_category', filters.category );
		}

		if ( filters.location ) {
			params.set( 'errand_location', filters.location );
		}

		if ( filters.budget ) {
			params.set( 'errand_budget', filters.budget );
		}

		if ( filters.duration ) {
			params.set( 'errand_duration', filters.duration );
		}

		if ( filters.search ) {
			params.set( 'errand_search', filters.search );
		}

		if ( page && page > 1 ) {
			params.set( 'paged', String( page ) );
		}

		const query = params.toString();
		const nextUrl = query
			? `${ window.location.pathname }?${ query }`
			: window.location.pathname;

		window.history.replaceState( {}, '', nextUrl );
	}

	function syncFiltersFromUrl() {
		const params = new URLSearchParams( window.location.search );

		$( '#errand-category' ).val( params.get( 'errand_category' ) || '' );
		$( '#errand-location' ).val( params.get( 'errand_location' ) || '' );
		$( '#errand-budget' ).val( params.get( 'errand_budget' ) || '' );
		$( '#errand-duration' ).val( params.get( 'errand_duration' ) || '' );
		$errandSearchInput.val( params.get( 'errand_search' ) || '' );
	}

	function scrollToErrands() {
		$( 'html, body' ).animate(
			{
				scrollTop: $errandSection.offset().top - 100,
			},
			400
		);
	}

	function fetchErrands( page ) {
		const filters = getFilterValues();
		const data = {
			action: 'ajax_filter',
			nonce: localVars.nonce,
			category: filters.category,
			location: filters.location,
			budget: filters.budget,
			duration: filters.duration,
			search: filters.search,
			paged: page || 1,
		};

		$errandsRow.addClass( 'is-loading' );

		$.ajax( {
			url: localVars.ajax_url,
			type: 'POST',
			data: data,
		} )
			.done( function( response ) {
				if ( response.success && response.data ) {
					$errandsRow.html( response.data.posts_html );
					$pagination.html( response.data.pagination_html || '' );
					updateUrlFromFilters( page || 1 );
				}
			} )
			.always( function() {
				$errandsRow.removeClass( 'is-loading' );
			} );
	}

	syncFiltersFromUrl();

	if ( new URLSearchParams( window.location.search ).get( 'errand_category' ) ) {
		scrollToErrands();
	}

	$filterForm.on( 'submit', function( event ) {
		event.preventDefault();
		fetchErrands( 1 );
		scrollToErrands();
	} );

	if ( $searchForm.length ) {
		$searchForm.on( 'submit', function( event ) {
			event.preventDefault();
			fetchErrands( 1 );
			scrollToErrands();
		} );
	}

	$pagination.on( 'click', '[data-value]', function( event ) {
		event.preventDefault();

		const page = parseInt( $( this ).data( 'value' ), 10 );

		if ( ! page || $( this ).hasClass( 'current' ) ) {
			return;
		}

		fetchErrands( page );
		scrollToErrands();
	} );
} );
